import React from "react"
import { GoogleMap, Marker, withGoogleMap, withScriptjs } from "react-google-maps"
import { compose, withProps } from "recompose"

const MapComponent = compose(
    withProps({
        googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyCrggUEQEDx7yKV8XA5MmtS75eDwbnbRY8&v=3.exp&libraries=geometry,drawing,places",
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: screen.width < 768 ? `200px` : `250px` }} />,
        mapElement: <div
            style={
                window.location.href.includes("/receipt/")
                    ? { height: `100%`, borderRadius: `25px` }
                    : { height: `100%`, borderBottomLeftRadius: `25px`, borderBottomRightRadius: `25px` }
            }
        />,
    }),
    withScriptjs,
    withGoogleMap
)((props: any) =>
    <GoogleMap
        defaultZoom={12}
        defaultCenter={props.marker}
    >
        <Marker position={props.marker} />
    </GoogleMap>
)

export default MapComponent






// WEBPACK FOOTER //
// ./src/components/map.tsx